function normalize(value) {
  return (value || "").trim().toLowerCase();
}

export function buildMentionOptions({
  members = [],
  query = "",
  includeAiCommand = false,
  onlineUserIds = new Set(),
} = {}) {
  const specials = [
    {
      id: "all",
      name: "All",
      subtitle: "Notifies everyone",
      kind: "all",
      pinned: true,
    },
    {
      id: "ai",
      name: "Tiger ZERO AI",
      subtitle: "AI assistant",
      kind: "ai",
      pinned: true,
    },
  ];

  if (includeAiCommand) {
    specials.push({
      id: "ai-cmd",
      name: "Tiger ZERO AI Command",
      subtitle: "Command this AI",
      kind: "ai-command",
      pinned: true,
    });
  }

  const people = [];
  (Array.isArray(members) ? members : []).forEach((member) => {
    const user = member?.user;
    if (!user?.id || !user.display_name) return;
    people.push({
      id: user.id,
      name: user.display_name,
      subtitle: user.email_address || "",
      kind: "person",
      pinned: false,
      profilePhoto: user.profile_photo,
      isOnline: onlineUserIds.has(user.id),
    });
  });

  const normalizedQuery = normalize(query);
  const matches = (option) =>
    !normalizedQuery || option.name.toLowerCase().includes(normalizedQuery);

  const matchedPeople = people.filter(matches).sort((a, b) => {
    if (!normalizedQuery) return a.name.localeCompare(b.name);
    const aStarts = a.name.toLowerCase().startsWith(normalizedQuery) ? 0 : 1;
    const bStarts = b.name.toLowerCase().startsWith(normalizedQuery) ? 0 : 1;
    if (aStarts !== bStarts) return aStarts - bStarts;
    return a.name.localeCompare(b.name);
  });

  return [...specials.filter(matches), ...matchedPeople];
}
